// extracted by mini-css-extract-plugin
export default {"SVG":"startPage_SVG__sRSe-","videoPlay":"startPage_videoPlay__Lda7G"};